import { updateServicePlansAction } from "../../actions/ServicePlans/manageServicePlans";
import showToaster from "../../helpers/toasterMessages/showToaster";

async function submit(values, dispatch) {
    if (!values?.mediaImage) {
        showToaster({ messageId: 'servicePlanImageError', toasterType: 'error' });
        return
    }
    dispatch(updateServicePlansAction(values))
}

export default submit;